/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Statsplanstoday2Inputs */

const en_statsplanstoday2 = /** @type {(inputs: Statsplanstoday2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Today`)
};

const de_statsplanstoday2 = /** @type {(inputs: Statsplanstoday2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Heute`)
};

/**
* | output |
* | --- |
* | "Today" |
*
* @param {Statsplanstoday2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const statsplanstoday2 = /** @type {((inputs?: Statsplanstoday2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Statsplanstoday2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_statsplanstoday2(inputs)
	return de_statsplanstoday2(inputs)
});
export { statsplanstoday2 as "statsPlansToday" }